import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { useDispatch } from "react-redux";
import storage from "../../../utils/storage";
import { useFormik } from "formik";
import appActions from "../../../appActions";
import { InputText } from "primereact/inputtext";
import { statusOptions } from "../../../utils/mics";

const SiteGroupForm = ({ siteGroup, isEditMode, isViewMode, isCopyMode, onClose, onSave }) => {
    
    const dispatch = useDispatch();
    const currentUser = JSON.parse(storage.get('loginUser'));

    const formik = useFormik({
        initialValues: {
            groupId: siteGroup?.groupId  || "",
            groupCode: siteGroup?.groupCode  || "",
            groupName: siteGroup?.groupName  || "",
            status: siteGroup?.status || "Active",
            lastUpdatedBy: currentUser?.userId || "",
        },
        enableReinitialize: true,
        validate: (data) => {
            let errors = {};
            if (!data.groupCode) errors.groupCode = 'Site Group Code is required.';
            if (!data.groupName) errors.groupName = 'Site Group Name is required.';
            if (!data.status) errors.status = 'Status is required.';
            return errors;
        },
        onSubmit: (values) => {
            const data = {
                ...values,
                id: isEditMode ? siteGroup?.id : null,
                lastUpdatedBy: currentUser?.userId,
            }
            handleCreate(data);
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getFormErrorMessage = (name) => {
        return (
            isFormFieldValid(name) && (
                <small className="p-error">{formik.errors[name]}</small>
            )
        );
    };

    const handleCreate = (data) => {
        if (isEditMode) {
            dispatch(appActions.SITEGROUP_UPDATE_REQUEST(data));
        } else if(isCopyMode) {
            delete data?.id
            dispatch(appActions.SITEGROUP_CREATE_REQUEST(data));
        } else {
            delete data?.id
            dispatch(appActions.SITEGROUP_CREATE_REQUEST(data));
        }
        onSave();
        onClose();
    };

    const handleClose = () => {
        onClose();
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="grid formgrid mt-2">

                    <div className="field col-4">
                        <label htmlFor="groupCode" className="flex align-items-center required"> Site Group Code </label>
                        <InputText
                            className="w-full"
                            id="groupCode"
                            value={formik.values.groupCode}
                            onChange={formik.handleChange}
                            placeholder="Site Group Code"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('groupCode')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="groupName" className="flex align-items-center required"> Site Group Name </label>
                        <InputText
                            className="w-full"
                            id="groupName"
                            value={formik.values.groupName}
                            onChange={formik.handleChange}
                            placeholder="Site Group Name"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('groupName')}
                    </div>

                    <div className="field col-4">
                        <label htmlFor="status" className="flex align-items-center required"> Status </label>
                        <Dropdown
                            className="w-full"
                            id="status"
                            value={formik.values.status}
                            options={statusOptions}
                            optionLabel="name"
                            optionValue='code'
                            onChange={(e) => formik.setFieldValue('status', e.value)}
                            placeholder="Status"
                            disabled={isViewMode}
                        />
                        {getFormErrorMessage('status')}
                    </div>

                    <div className="field col-12">
                        <div className="flex justify-content-end mt-4">
                            {isViewMode ? (
                                <Button
                                    type="button"
                                    label="Close"
                                    onClick={handleClose}
                                    severity="secondary"
                                />
                            ) : (
                                <Button
                                    type="submit"
                                    label={isEditMode ? 'Update' : 'Create'}
                                    severity="basic"
                                />
                            )}
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
}

export default SiteGroupForm;
